import { useTranslation } from 'react-i18next';
import { LoadingButton } from 'src/components/atoms/loading-button/loading-button';
import { MoreFilters } from 'src/components/organisms/more-filters';
import { useInfiniteEmployeesGroups } from 'src/features/employees-groups/api/hooks/use-infinite-employees-groups';
import { EmployeeGroupResponse } from 'src/features/employees-groups/api/types/response/employee-group.response';
import { useUserStore } from 'src/store/user-store';
import { Anchor } from 'src/types/anchor';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup as IFilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';

interface Props {
  anchor: Anchor;
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  resetFilters: () => void;
}

export const BookingRulesMoreFilters = ({
  handleChangeFilterValue,
  filters,
  resetFilters,
  anchor,
}: Props) => {
  const { t } = useTranslation(['bookingRules', 'common']);

  const { meilisearchToken } = useUserStore();

  const employeesGroupsQuery = useInfiniteEmployeesGroups(
    10,
    Boolean(meilisearchToken),
  );

  const allEmployeesGroups =
    employeesGroupsQuery.data?.pages?.reduce<EmployeeGroupResponse[]>(
      (acc, page) => {
        return [...acc, ...page.hits];
      },
      [],
    ) ?? [];

  const filterGroups: IFilterGroup<string>[] = [
    {
      id: 1,
      type: 'assignedEmployeeGroups.token',
      label: t('bookingRules:common.columns.employeeGroups'),
      singleOption: false,
      items: allEmployeesGroups.map(group => ({
        id: group.token,
        label: group.name,
        value: group.token,
      })),
      bottomSlot: (
        <LoadingButton
          fullWidth
          variant="outlined"
          onClick={() => employeesGroupsQuery.fetchNextPage()}
          loading={employeesGroupsQuery.isFetchingNextPage}
          disabled={!employeesGroupsQuery.hasNextPage}>
          {t('common:button.loadMore')}
        </LoadingButton>
      ),
    },
  ];

  return (
    <MoreFilters
      anchor={anchor}
      filters={filters}
      handleChangeFilterValue={handleChangeFilterValue}
      resetFilters={resetFilters}
      filterGroups={filterGroups}
    />
  );
};
